<template>
  <div class="padding-xl">
    <div class="flex justify-start align-center solid-bottom">
      <div class="nav padding-right-xl">
        <div style="cursor:pointer;" class="cu-item text-lg" :class="index==TabCur?'text-red cur':''"
             v-for="(item,index) in tabs" :key="index"
             @click="tabSelect" :data-id="index">
          <div class="padding-lr">{{ item.label }}</div>
        </div>
      </div>
    </div>
    <div class="padding-top-xl padding-lr-xs">
      <div v-if="tableData.length === 0" class="text-center">
        <div class="padding"></div>
        <div class="padding text-xl">暂无订单</div>
        <div class="padding"></div>
      </div>
      <div v-else>
        <el-table
          border
          :stripe="true"
          :height="500"
          :max-height="500"
          :data="tableData"
          :header-cell-style="headerStyle"
          :cell-style="cellStyle"
          :row-style="{height: '40px',padding: '0'}"
          style="width: 100%">
          <el-table-column
            type="index"
            width="50">
          </el-table-column>
          <el-table-column
            label="操作"
            width="360">
            <template slot-scope="scope">
              <el-popconfirm title="确定要取消该订单？" class="padding-right" @confirm="cancelOrder(scope.row.id)">
                <el-button slot="reference"
                           :disabled="scope.row.state === -1 || scope.row.state === 11  || (scope.row.invoiceAsk && scope.row.invoiceAsk.state === 1 ) || (scope.row.pay && scope.row.pay.payState === 1 )"
                           type="text">取消
                </el-button>
              </el-popconfirm>
              <el-button @click="nav2Edit(scope.row)"
                         :disabled="scope.row.state === -1 || scope.row.state === 11  || (scope.row.invoiceAsk && scope.row.invoiceAsk.state === 1 ) || (scope.row.pay && scope.row.pay.payState === 1 )"
                         type="text">修改
              </el-button>
              <el-button @click="nav2Pay(scope.row)" :disabled="canPay(scope.row)"
                         type="text">支付
              </el-button>
              <el-button @click="nav2Invoice(scope.row)"
                         :disabled="canInvoice(scope.row)"
                         type="text">开票
              </el-button>
              <el-button @click="nav2Order(scope.row)" type="text">订单详情</el-button>
              <el-button @click="nav2Logistics(scope.row)" :disabled="scope.row.shippedFlag !== 1" type="text">
                物流详情
              </el-button>
            </template>
          </el-table-column>
          <el-table-column label="订单">
            <el-table-column
              prop="no"
              label="订单编号"
              width="210">
            </el-table-column>
            <el-table-column
              prop="createTime"
              label="订单日期"
              width="180">
            </el-table-column>
            <el-table-column
              prop="total"
              label="条目数"
              width="65">
            </el-table-column>
            <el-table-column
              prop="type"
              label="订单类型"
              width="87">
            </el-table-column>
            <el-table-column
              prop="amount"
              label="订单金额"
              width="87">
            </el-table-column>
          </el-table-column>
          <el-table-column label="支付信息">
            <el-table-column
              prop="pay.payType"
              label="支付方式"
              width="87">
            </el-table-column>
            <el-table-column
              prop="pay.payState"
              label="支付状态"
              width="87">
              <template v-slot="scope">
                <span v-if="scope.row.pay && scope.row.pay.payState === 1">已支付</span>
                <span
                  v-else-if="scope.row.pay && scope.row.pay.payState === 9">已退款</span>
                <span class="text-blue" style="text-decoration:underline;cursor: pointer"
                      @click="showPayApprovalDesc(scope.row)"
                      v-else-if="scope.row.pay && scope.row.pay.payType === '银行转账' && scope.row.pay.approvalDesc && scope.row.pay.approvalDesc !== ''">审核失败</span>
                <span
                  v-else-if="scope.row.pay && scope.row.pay.payType === '银行转账' && scope.row.pay.payState === 2">审核中</span>
                <span v-else-if="scope.row.pay && scope.row.pay.payState === 0">支付失败</span>
                <span v-else>未支付</span>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="发票信息">
            <el-table-column
              prop="invoice.invoiceType"
              label="发票类型"
              width="87">
            </el-table-column>
            <el-table-column
              prop="invoice.invoiceState"
              label="开票状态"
              width="87">
              <template v-slot="scope">
                <span v-if="scope.row.invoice && scope.row.invoice.invoiceState === 1">已开票</span>
                <span v-else-if="scope.row.invoice && scope.row.invoice.invoiceState === 2">开票中</span>
                <span v-else-if="scope.row.invoice && scope.row.invoice.invoiceState === 0">开票失败</span>
                <span v-else-if="scope.row.invoice && scope.row.invoice.invoiceState === 9">发票已取消</span>
                <span class="text-blue" style="text-decoration:underline;cursor: pointer"
                      @click="showInvoiceApprovalDesc(scope.row)"
                      v-else-if="scope.row.invoiceAsk && scope.row.invoiceAsk.approvalDesc && scope.row.invoiceAsk.approvalDesc !== ''">审核失败</span>
                <span v-else-if="scope.row.invoiceAsk && scope.row.invoiceAsk.state === 2">审核中</span>
                <span v-else-if="scope.row.invoiceAsk && scope.row.invoiceAsk.state === 1">审核通过</span>
                <span v-else>未开票</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="invoice.invoiceState"
              label="下载发票"
              width="87">
              <template v-slot="scope">
                <el-link
                  v-if="scope.row.invoice && scope.row.invoice.callback && scope.row.invoice.callback.invoiceFile && scope.row.invoice.invoiceState !== 9"
                  type="primary" @click="openDownload(scope.row.invoice.callback.invoiceFile, scope.row)">下载
                </el-link>
              </template>
            </el-table-column>
          </el-table-column>
        </el-table>
        <div class="padding-tb-xl">
          <el-pagination
            background
            :page-size="page.size"
            :page-sizes="[10, 20, 40, 100]"
            layout="total, sizes, prev, pager, next"
            :total="page.total"
            @size-change="sizeChanged"
            @prev-click="prevClicked"
            @next-click="nextClicked"
            @current-change="currentChanged">
          </el-pagination>
        </div>
      </div>
    </div>
    <el-dialog :show-close="false" :close-on-click-modal="false"
               title="下载发票"
               :visible.sync="downloadShow"
               width="30%">
      <span v-for="(item,index) in invoiceList" :key="index" class="padding-right-lg">
        <el-link :href="item" type="primary" target="_blank">发票{{ index + 1 }}</el-link>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="downloadShow = false">关闭</el-button>
      </span>
    </el-dialog>
    <el-dialog :show-close="false" :close-on-click-modal="false"
               title="下载发票"
               :visible.sync="gotoDetailShow"
               width="30%">
      <span>
        <el-button type="primary" @click="nav2OrderWithoutSetSession()">点击跳转到订单详情页面下载发票</el-button>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="gotoDetailShow = false">关闭</el-button>
      </span>
    </el-dialog>
    <el-dialog :show-close="false" :close-on-click-modal="false"
               title="提前开票审核结果"
               :visible.sync="invoiceApprovalDescShow"
               width="30%">
      <span>{{ invoiceApprovalDesc }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="invoiceApprovalDescShow =  false">我知道了</el-button>
      </span>
    </el-dialog>
    <el-dialog :show-close="false" :close-on-click-modal="false"
               title="银行汇款凭证审核结果"
               :visible.sync="payApprovalDescShow"
               width="30%">
      <span>{{ payApprovalDesc }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="payApprovalDescShow =  false">我知道了</el-button>
      </span>
    </el-dialog>
    <el-dialog :show-close="false" :close-on-click-modal="false"
               title="无法开票"
               :visible.sync="disabledAfterDescShow"
               width="30%">
      <span>{{ invoiceConfig.disabledAfterDesc }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="disabledAfterDescShow =  false">我知道了</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import bs from '@/services/data/bs'
import config from '../../public/config/config'

export default {
  name: 'order-list',
  data () {
    return {
      invoiceConfig: config.invoice,
      disabledAfterDescShow: false,
      tabs: config.ORDER_STATE,
      downloadShow: false,
      gotoDetailShow: false,
      TabCur: 0,
      scrollLeft: 0,
      tableData: [],
      invoiceList: [],
      page: {
        number: 0,
        size: 10,
        total: 0
      },
      invoiceApprovalDescShow: false,
      payApprovalDescShow: false,
      invoiceApprovalDesc: '',
      payApprovalDesc: ''
    }
  },
  created () {
    this.user = JSON.parse(sessionStorage.getItem('user'))
    this.tabs = config.ORDER_STATE
    this.getList()
  },
  methods: {
    canPay (order) {
      if (order.state === -1) {
        return true
      }
      if (order.pay && order.pay.approvalDesc && order.pay.approvalDesc !== '') {
        return false
      }
      if (order.invoiceAsk && order.invoiceAsk.state === 1) {
        return true
      }
      if (order.invoiceAsk && order.invoiceAsk.approvalDesc && order.invoiceAsk.approvalDesc !== '') {
        return false
      }
      if (order.pay && order.pay.payState === 9) {
        return true
      }
      if (order.pay && order.pay.payType === 'B2B支付' && order.pay.payState > 1) {
        return false
      }
      return order.pay && order.pay.payState > 0
    },
    openDownload (files, order) {
      if (!order.invoiceType || order.invoiceType === 1) {
        this.invoiceList = files.split('#&#')
        this.downloadShow = true
      } else if (order.invoiceType === 2) {
        this.setOrderToSession(order, () => {
          this.gotoDetailShow = true
        })
      }
    },
    canInvoice (order) {
      if (order.state === -1) {
        return true
      }
      if (order.invoiceType && order.invoiceType === 2) {
        return true
      }
      if (!order.invoice) {
        if (order.invoiceAsk && order.invoiceAsk.state === 1) {
          return false
        } else if (order.pay && order.pay.payState === 1) {
          return false
        }
      } else if (this.invoiceConfig.requestAfterReverse === false && order.invoice.reversed === 1) {
        return false
      } else {
        return true
      }
      return true
    },
    getList () {
      bs.order.list(this.tabs[this.TabCur].state, this.page, (res) => {
        if (res.code === 200) {
          if (res.data.list) {
            this.tableData = res.data.list
          } else {
            this.tableData = []
          }
          this.page = res.data.page
        }
      })
    },
    sizeChanged (size) {
      this.page.size = size
      this.getList()
    },
    prevClicked () {
      this.page.number--
      this.getList()
    },
    nextClicked () {
      this.page.number++
      this.getList()
    },
    currentChanged (number) {
      this.page.number = number - 1
      this.getList()
    },
    tabSelect (e) {
      if (this.TabCur === parseInt(e.currentTarget.dataset.id)) {
        return false
      }
      this.TabCur = parseInt(e.currentTarget.dataset.id)
      this.scrollLeft = (e.currentTarget.dataset.id - 1) * 60
      this.getList()
    },
    headerStyle () {
      return 'text-align:center;color:#666666;font-size:14px;padding:6px 0'
    },
    cellStyle (obj) {
      return 'text-align:center;padding:0'
    },
    cancelOrder (id) {
      bs.order.cancel(id, (res) => {
        if (res.code === 200) {
          this.$message({
            message: '订单取消成功',
            type: 'success'
          })
          this.getList()
        } else {
          this.$message.error('订单取消失败')
        }
      })
    },
    setOrderToSession (order, success) {
      bs.order.detail(order.id, (res) => {
        if (res.code === 200) {
          order.list = res.data
          sessionStorage.setItem('order', JSON.stringify(order))
          success()
        }
      })
    },
    nav2Edit (order) {
      this.setOrderToSession(order, () => {
        if (order.type === '零散订阅') {
          this.$router.push({ path: '/pages/subscribe/subscribe' })
        } else if (order.type === '集体订阅') {
          this.$router.push({ path: '/pages/subscribe/subscribe-multi' })
        }
      })
    },
    nav2Pay (order) {
      this.setOrderToSession(order, () => {
        this.$router.push({ path: '/pages/subscribe/pay' })
      })
    },
    nav2Invoice (order) {
      if (order.pay && order.pay.payTime && this.invoiceConfig.disabledAfter > 0 && new Date().getTime() > new Date(order.pay.payTime).getTime() + this.invoiceConfig.disabledAfter) {
        this.disabledAfterDescShow = true
        return false
      }
      this.setOrderToSession(order, () => {
        this.$router.push({ path: '/pages/subscribe/invoice' })
      })
    },
    nav2Order (order) {
      this.setOrderToSession(order, () => {
        this.$router.push({ path: '/pages/order-info' })
      })
    },
    nav2OrderWithoutSetSession () {
      this.$router.push({ path: '/pages/order-info' })
    },
    nav2Logistics (order) {
      sessionStorage.setItem('order', JSON.stringify(order))
      this.$router.push({ path: '/pages/logistics-info' })
    },
    showInvoiceApprovalDesc (order) {
      this.invoiceApprovalDesc = order.invoiceAsk.approvalDesc
      this.invoiceApprovalDescShow = true
    },
    showPayApprovalDesc (order) {
      this.payApprovalDesc = order.pay.approvalDesc
      this.payApprovalDescShow = true
    }

  }
}
</script>

<style scoped>

</style>
